import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/Header.css";
import { useAuth } from "../../context/AuthContext";

const Header = () => {
  const { token, user, logout } = useAuth();
  const navigate = useNavigate();

  const [showJBrowse, setShowJBrowse] = useState(false);
  const [headerDropdownOpen, setHeaderDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const toggleHeaderDropdown = () => {
    setHeaderDropdownOpen((prev) => !prev);
  };

  // --- Fullscreen JBrowse 2 view ---
  if (showJBrowse) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#000",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 20px",
            background: "#1a1a1a",
          }}
        >
          <h3 style={{ color: "white", margin: 0 }}>
            🧬 JBrowse 2 Genome Viewer
          </h3>
          <button
            onClick={() => setShowJBrowse(false)}
            style={{
              background: "#4CAF50",
              border: "none",
              color: "white",
              padding: "6px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ⬅ Back
          </button>
        </div>

        <iframe
          src="/jbrowse-data/?config=config.json"
          title="JBrowse 2"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    );
  }

  return (
    <header className="header">
      <div className="header-inner">

        {/* TOP SECTION */}
        <div className="header-top">
          <div className="logo">
            <img
              src={`${process.env.PUBLIC_URL}/images/teff.png`}
              alt="Logo"
              style={{ width: "150px", height: "auto" }}
            />

            <div className="site-title">
              <h1><i>TefDB</i></h1>
              <p
                className="site-subtitle"
                style={{
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  fontStyle: "italic",
                  margin: "0.2rem 0 0",
                  cursor: "default",
                }}
              >
                <span
                  style={{
                    background:
                      "linear-gradient(90deg, #FF6B6B, #FFD93D, #6BCB77)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    display: "inline-block",
                  }}
                >
                  Empowering Teff Research Worldwide
                </span>{" "}
                🌍
              </p>
            </div>
          </div>

          {/* ✅ RESTORED RIGHT IMAGE */}
          <div className="header-image-right">
            <img
              src={`${process.env.PUBLIC_URL}/images/tef.png`}
              alt="Tef"
              className="tef-top-image"
            />
          </div>
        </div>

        {/* NAVIGATION */}
        <div className="header-bottom">
          <nav className="navbar">
            <ul className="nav-links">

              <li><Link to="/home">Home</Link></li>
              <li><Link to="/about">About</Link></li>

              {/* TOOLS DROPDOWN */}
              <li className="dropdown">
                <span
                  className="dropdown-toggle"
                  onClick={toggleHeaderDropdown}
                >
                  Tools
                </span>

                {headerDropdownOpen && (
                  <ul className="header-dropdown-menu open">

                    <li>
                      <Link
                        to="/blast"
                        onClick={() => setHeaderDropdownOpen(false)}
                      >
                        BLAST
                      </Link>
                    </li>

                    {/* ✅ EXTERNAL: Primer3Plus */}
                    <li>
                      <span
                        className="header-dropdown-link"
                        onClick={() => {
                          window.open(
                            "https://www.primer3plus.com/index.html",
                            "_blank"
                          );
                          setHeaderDropdownOpen(false);
                        }}
                      >
                        Primer Design
                      </span>
                    </li>

                    {/* ✅ EXTERNAL: Clustal Omega */}
                    <li>
                      <span
                        className="header-dropdown-link"
                        onClick={() => {
                          window.open(
                            "https://www.ebi.ac.uk/jdispatcher/msa/clustalo",
                            "_blank"
                          );
                          setHeaderDropdownOpen(false);
                        }}
                      >
                        Clustal Omega
                      </span>
                    </li>

                    {/* INTERNAL */}
                    <li>
                      <span
                        className="header-dropdown-link"
                        onClick={() => {
                          setShowJBrowse(true);
                          setHeaderDropdownOpen(false);
                        }}
                      >
                        Genome Browser
                      </span>
                    </li>
                  </ul>
                )}
              </li>
              <li><Link to="/genomeassembly" className="genome-button">Genome</Link></li>
              <li><Link to="/faqs" className="faqs-button">FAQs</Link></li>
              <li><Link to="/help" className="help-button">Help</Link></li>
              <li><Link to="/contact" className="contact-button">Feedback</Link></li>

              {!token ? (
                <li><Link to="/register">Register</Link></li>
              ) : (
                <>
                  <li className="username-label">
                    👤 {user?.username || "User"}
                  </li>
                  <li>
                    <button onClick={handleLogout}>Logout</button>
                  </li>
                </>
              )}

            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
